module.exports = __webpack_public_path__ + "static/media/toprated.746dd8f1.png";